import { ReactNode } from 'react';
import styles from './IconMenu.module.css';
import { classNames } from '@axo/shared/util/dom';

interface IIconMenu {
  className?: string;
  children: ReactNode;
  leftMenu?: ReactNode;
}

/**
 * @deprecated Reason: Sometimes a little copy is better than a little dependency
 */
export const IconMenu = ({ children, className, leftMenu }: IIconMenu) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.menu}>{leftMenu}</div>
      <div className={styles.menu}>{children}</div>
    </div>
  );
};
